import React from 'react';
import {BarElement, CategoryScale, Chart as ChartJS, LinearScale, Tooltip,} from 'chart.js';
import {Typography,} from '@mui/material';
import './CorporateRisk.css';
import HeatBar from "./HeatBar";
import ScoreCard from "./ScoreCard";
import TextCard from "./TextCard";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const CorporateRiskSummary = (company, chartRef, isLoading) => {
    const corporateRisk = corporateRiskParser(company, chartRef);
    return (
        <div id="content" className={"bg-black"}
             style={{
                 width: "100%", margin: "10px auto 0 auto", padding: "0 15px",
                 fontSize: "1rem", fontWeight: "500", lineHeight: "1.5", height: "20%"
             }}>
            {isLoading && (<Typography variant="h5" className="gray-text">Loading...</Typography>)}
            {!isLoading && (corporateRisk)}
        </div>
    );
}

const corporateRiskParser = (company, chartRef) => {
    return (
        <>
            <table className={"table table-dark"} style={{backgroundColor: "black"}}>
                <tbody>
                <tr>
                    <td width={'25%'} style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">Corporate Score</Typography>
                    </td>
                    <td width={'25%'}>
                        <ScoreCard title='Risk Score' content={`${company.risk_score}/${company.max_score}`}/>
                    </td>
                    <td width={'25%'}>
                        <ScoreCard title='Resilience Score'
                                   content={`${company.resilience_score}/${company.max_score}`}/>
                    </td>
                    <td width={'25%'}>
                        <ScoreCard title='Exposure Score'
                                   content={`${company.exposure_score}/${company.max_score}`}/>
                    </td>
                </tr>
                <tr>
                    <td style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">Rating</Typography>
                    </td>
                    <td>
                        <HeatBar label={'Risk'} score={company.risk_score} rating={company.risk_rating}
                                 chartRef={chartRef}/>
                    </td>
                    <td>
                        <HeatBar label={'Resilience'} score={company.resilience_score}
                                 rating={company.resilience_rating}
                                 chartRef={chartRef} reverse={true}/>
                    </td>
                    <td>
                        <HeatBar label={'Exposure'} score={company.exposure_score} rating={company.exposure_rating}
                                 chartRef={chartRef}/>
                    </td>
                </tr>
                <tr>
                    <td style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">Rating Relative to Peers</Typography>
                    </td>
                    <td>
                        <ScoreCard title={company.risk_rating_relative}
                                   content={`Average of SP500 Energy Sector is ${company.risk_peer_avg}`}/>
                    </td>
                    <td>
                        <ScoreCard title={company.resilience_rating_relative}
                                   content={`Average of SP500 Energy Sector is ${company.resilience_peer_avg}`}/>
                    </td>
                    <td>
                        <ScoreCard title={company.exposure_rating_relative}
                                   content={`Average of SP500 Energy Sector is ${company.exposure_peer_avg}`}/>
                    </td>
                </tr>
                <tr>
                    <td style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">What it measures</Typography>
                    </td>
                    <td>
                        <TextCard
                            content={`The Risk Score describes a corporation’s vulnerability to physical climate risk, taking into account both hazard exposure and resilient capabilities. Higher Risk Scores reflect large exposure which can be partially reduced by high resilience`}/>
                    </td>
                    <td>
                        <TextCard
                            content={`The Resilience Score evaluates a corporation’s ability to understand, prepare for, respond to, and mitigate the impacts of physical climate risk. Higher values indicate greater ability to mitigate impacts of hazard events.`}/>
                    </td>
                    <td>
                        <TextCard
                            content={`The Exposure Score is a portfolio-level metric which reflects a company’s overall exposure to physical climate hazards. Larger values indicate greater exposure.`}/>
                    </td>
                </tr>
                </tbody>
            </table>
        </>
    )
}

export default CorporateRiskSummary;
